/**
 * 解析 TEMU publishOrEdit 响应是否真正成功。
 * 注意：网关 code=0 也可能是校验失败（info.success=false，且无 spu_name/skc_list）。
 */

function collectValidationMessages(res) {
  const info = res?.info && typeof res.info === 'object' ? res.info : res;
  if (!info || typeof info !== 'object') return [];
  const buckets = [
    info.pre_valid_result,
    info.mcc_valid_result,
    info.preValidResult,
    info.mccValidResult,
  ];
  const out = [];
  buckets.forEach((arr) => {
    if (!Array.isArray(arr)) return;
    arr.forEach((row) => {
      const messages = row?.messages;
      const extras = [];
      const code = String(row?.code || row?.error_code || row?.errorCode || '').trim();
      const field = String(row?.field || row?.field_name || row?.fieldName || '').trim();
      if (code || field) extras.push(`[code=${code || '-'} field=${field || '-'}]`);

      if (Array.isArray(messages)) {
        messages.forEach((m) => {
          const text = m == null ? '' : String(m).trim();
          if (!text) return;
          const formName = String(row?.form_name || row?.formName || '').trim();
          out.push(formName ? `${formName}：${text}` : text);
        });
        extras.forEach((e) => out.push(e));
        return;
      }
      const single = String(row?.message || row?.msg || '').trim();
      if (single) {
        const formName = String(row?.form_name || row?.formName || '').trim();
        out.push(formName ? `${formName}：${single}` : single);
      }
      extras.forEach((e) => out.push(e));
    });
  });
  return out;
}

export function isTemuPublishSuccess(res) {
  if (!res || typeof res !== 'object') return false;
  if (res.ok === true) return true;
  // 后端 requireResult 已解包：response 顶层即 { productId, productSkcList, ... }
  if (res.productId != null || res.productSkcList != null || res.productSkuList != null) {
    return true;
  }
  if (res.result && (
    res.result.productId != null
    || res.result.productSkcList != null
    || res.result.productSkuList != null
  )) {
    return true;
  }
  if (res.info && typeof res.info === 'object' && Object.prototype.hasOwnProperty.call(res.info, 'success')) {
    return res.info.success === true;
  }
  if (typeof res.success === 'boolean') {
    return res.success === true;
  }
  const errorCode = res.errorCode ?? res.error_code;
  if (String(errorCode) === '1000000') return true;
  const code = res.code == null ? '' : String(res.code);
  return code === '0' || code === '000000';
}

export function extractTemuPublishFailMessage(res) {
  const validation = collectValidationMessages(res);
  if (validation.length) {
    return validation.slice(0, 8).join('；');
  }
  const detail = [
    res?.msg,
    res?.message,
    res?.errorMsg,
    res?.error_msg,
    res?.info?.msg,
    res?.info?.message,
  ]
    .map((v) => (v == null ? '' : String(v).trim()))
    .find((v) => v && v.toUpperCase() !== 'OK');
  return detail || '发布未成功，平台未返回货品 ID';
}

export function extractTemuPublishedSpu(res, payload = {}, formSpuName = '') {
  return String(
    res?.result?.productId
    || res?.info?.spu_name
    || res?.info?.spuName
    || res?.spu_name
    || res?.spuName
    || res?.info?.data?.spu_name
    || res?.info?.data?.spuName
    || res?.productId
    || payload?.spu_name
    || payload?.spuName
    || payload?.productName
    || formSpuName
    || ''
  ).trim();
}
